import { useEffect, useRef, useState } from "react";

// Анимация закрытия модалок.
//
// Модалки в панели монтируются условно ({open && <div/>}), и при закрытии
// React снимает их с экрана в тот же кадр — CSS-анимации закрытия просто негде
// проиграться. Хук держит окно смонтированным ещё DIALOG_CLOSE_MS после того,
// как open стал false, и отдаёт state: "open" | "closed" — его кладут в
// data-state на подложку и карточку, а index.css по нему играет вход и выход
// (рецепт с nexfill.ws: подложка гаснет, карточка гаснет, сжимается до 95 %
// и слегка уезжает вниз).
//
// Пока идёт выход, компонент должен рисоваться в том же виде, что и до
// закрытия: сбрасывать форму или отдавать null по !open нельзя, иначе окно
// «моргнёт» пустым перед исчезновением. Поэтому дочерним модалкам родитель
// передаёт isOpen всегда true и отдельно dialogState.
export const DIALOG_CLOSE_MS = 200;

export const useModalPresence = (open, duration = DIALOG_CLOSE_MS) => {
  const isOpen = Boolean(open);
  const [mounted, setMounted] = useState(isOpen);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setMounted(true);
      return undefined;
    }
    if (!mounted) return undefined;
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      setMounted(false);
    }, duration);
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isOpen, mounted, duration]);

  // mounted || isOpen: в первый же рендер после открытия окно уже на экране,
  // не дожидаясь эффекта — иначе кадр задержки на каждом открытии.
  return { mounted: mounted || isOpen, state: isOpen ? "open" : "closed" };
};

// Атрибуты для подложки и карточки — чтобы не повторять по всем модалкам.
export const overlayMotionProps = (state) => ({ "data-kl-overlay": "", "data-state": state });
export const dialogMotionProps = (state) => ({ "data-kl-dialog": "", "data-state": state });

// Пока играет выход, содержимое окна должно остаться прежним, хотя стейт уже
// сброшен закрытием (account: null, value: ""). Возвращает значение как есть,
// пока open, и последнее «открытое» значение — пока окно догорает.
export const useLastOpenValue = (value, open) => {
  const ref = useRef(value);
  useEffect(() => {
    if (open) ref.current = value;
  });
  return open ? value : ref.current;
};
